export const RELATION_TYPES = [
  { value: 'PRIMARY', label: '주요' },
  { value: 'RELATED', label: '관련' }
]

export function relationLabel(value) {
  return RELATION_TYPES.find((type) => type.value === value)?.label || value
}

/** 연결 목록을 건강 영역 순서대로 묶는다. 영역 순서는 서버가 준 areas 순서를 따른다. */
export function groupLinksByArea(links = [], areas = []) {
  const order = new Map(areas.map((area, index) => [area.code, index]))
  const groups = new Map()
  for (const link of links) {
    if (!groups.has(link.areaCode)) {
      groups.set(link.areaCode, { areaCode: link.areaCode, areaLabel: link.areaLabel || link.areaCode, links: [] })
    }
    groups.get(link.areaCode).links.push(link)
  }
  return [...groups.values()]
    .sort((left, right) => (order.get(left.areaCode) ?? 999) - (order.get(right.areaCode) ?? 999))
    .map((group) => ({ ...group, links: [...group.links].sort((a, b) => a.sortOrder - b.sortOrder || a.id - b.id) }))
}

/** 보장 선택지를 대분류별로 묶는다(select의 optgroup). */
export function groupCoverageOptions(coverages = []) {
  const groups = new Map()
  for (const coverage of coverages) {
    const key = coverage.group || '기타'
    if (!groups.has(key)) groups.set(key, [])
    groups.get(key).push(coverage)
  }
  return [...groups.entries()].map(([label, options]) => ({ label, options }))
}

/** 화면 입력을 API 요청으로 바꾼다. 순서를 비우면 서버가 영역의 마지막 다음 번호를 붙인다. */
export function toLinkRequest(form) {
  const sortOrder = form.sortOrder === '' || form.sortOrder === null || form.sortOrder === undefined
    ? null
    : Number(form.sortOrder)
  return {
    areaCode: form.areaCode,
    coverageCode: form.coverageCode,
    relationType: form.relationType || 'RELATED',
    sortOrder,
    enabled: form.enabled !== false
  }
}

/** 저장 전에 화면에서 거를 수 있는 오류. 없으면 빈 문자열. */
export function validateLinkForm(form, links = [], editingId = null) {
  if (!form.areaCode) return '건강 영역을 선택해 주세요.'
  if (!form.coverageCode) return '보장을 선택해 주세요.'
  if (form.sortOrder !== '' && form.sortOrder !== null && form.sortOrder !== undefined) {
    const value = Number(form.sortOrder)
    if (!Number.isInteger(value) || value < 0) return '순서는 0 이상의 정수로 입력해 주세요.'
  }
  const duplicate = links.some((link) => link.id !== editingId
    && link.areaCode === form.areaCode && link.coverageCode === form.coverageCode)
  return duplicate ? '이미 같은 건강 영역과 보장이 연결되어 있습니다.' : ''
}

export function isLinkChanged(link, draft) {
  return link.relationType !== draft.relationType
    || Number(link.sortOrder) !== Number(draft.sortOrder)
    || link.enabled !== draft.enabled
}
